<script>
import Background from '@layouts/Background'
import ThirdpartyCardGroup from '@components/euro_pos/ThirdpartyCardGroup.vue'
import RedeemedCouponsTable from '@components/euro_pos/RedeemedCouponsTable.vue'
import LogsPaylessTable from '@components/euro_pos/LogsPaylessTable.vue'
import CashRegisterForm from '@components/euro_pos/CashRegisterForm.vue'
import HabeasDataForm from '@components/euro_pos/HabeasDataForm.vue'
import PaylessQr from '@components/euro_pos/PaylessQr.vue'
import { mapGetters } from 'vuex'
import { BIcon, BIconExclamationCircleFill } from 'bootstrap-vue'

// import Main from '@layouts/main'

// Cajas POS
// import { authComputed } from '@state/helpers'

export default {
  page: {
    title: 'Euro POS',
  },
  components: {
    Background,
    BIcon,
    BIconExclamationCircleFill,
    ThirdpartyCardGroup,
    RedeemedCouponsTable,
    LogsPaylessTable,
    CashRegisterForm,
    HabeasDataForm,
    PaylessQr,
  },
  data() {
    return {
      tabIndex: 0,
      enabledTabs: false,

      manuals: {
        0: [
          {
            step: 1,
            description:
              'Seleccione el <strong>centro operativo</strong> donde se encuentra actualmente',
            image_path: require('@assets/images/manuals/caja1.gif'),
            type: 'standard',
          },
          {
            step: 2,
            description:
              'Indique la <strong>caja</strong> donde se encuentra ubicado.',
            image_path: require('@assets/images/manuals/caja2.gif'),
            type: 'standard',
          },
          {
            step: 3,
            description:
              'Indique su  <strong>código de cajero</strong>.',
            image_path: require('@assets/images/manuals/caja3.gif'),
            type: 'standard',
          },
          {
            step: null,
            description:
              '<strong class="text-warning">Recuerde</strong> que tanto el <strong>centro operativo</strong> como el \
            <strong>número de caja</strong> y el <strong>código de cajero</strong> deben estar correctamente <strong>diligenciados</strong> \
            para <strong>activar las demás pestañas</strong> y continuar con los procesos de <strong>habeas data, redención de bonos, generación de reportes y Payless</strong>. ',
            image_path: null,
            type: 'info',
          },
        ],
        1: [
          {
            step: 1,
            description:
              'Seleccione el <strong>tipo del documento</strong> del cliente.',
            image_path: require('@assets/images/manuals/1_1_document_type.gif'),
            type: 'standard',
          },
          {
            step: 2,
            description:
              'Indique el <strong>número de documento</strong> del cliente. Presione el botón de <strong class="text-primary">enviar.</strong>',
            image_path: require('@assets/images/manuals/1_2_document.gif'),
            type: 'standard',
          },
          {
            step: null,
            description:
              '<strong class="text-warning">Recuerde</strong> que si el usuario no posee habeas data debe indicar el número de celular para continuar el registro.',
            image_path: null,
            type: 'info',
          },

          {
            step: 3,
            description:
              'Indique el <strong>número de celular</strong>, presione el botón de <strong class="text-primary">enviar.</strong>',
            image_path: require('@assets/images/manuals/1_3_mobile.gif'),
            type: 'standard',
          },
          {
            step: null,
            description:
              '<strong class="text-warning">Nota:</strong> Al <strong>cliente</strong> le llegara un <strong> mensaje de texto </strong> para <strong>diligenciar el formulario</strong> de autorización y tratamiento de datos. ',
            image_path: null,
            type: 'info',
          },
        ],
        2: [
          {
            step: 1,
            description:
              'Seleccione el <strong>aliado</strong> correspondiente al bono.',
            image_path: require('@assets/images/manuals/2_1_thirdparty.gif'),
            type: 'standard',
          },
          {
            step: 2,
            description:
              'Indique el <strong>tipo y número de documento</strong> del cliente. Presione el botón de <strong class="text-primary">consultar.</strong>',
            image_path: require('@assets/images/manuals/2_2_redeem_type_1.gif'),
            type: 'standard',
          },
          {
            step: null,
            description:
              '<strong class="text-warning">Recuerde</strong> que el proceso de <strong>redención</strong> se realiza de manera <strong>automática</strong>  cuando el bono esta asociado a un documento, solo debe <strong>indicar el método de pago</strong> correspondiente al aliado en el momento de facturar y omitir los siguientes pasos.',
            image_path: null,
            type: 'info',
          },

          {
            step: 3,
            description:
              'Si el bono <strong>es alfanumérico,</strong> ingrese solo los <strong>últimos 6 caracteres</strong> del bono, y presione <strong class="text-primary">consultar.</strong>',
            image_path: require('@assets/images/manuals/2_3_redeem_type_2.gif'),
            type: 'standard',
          },
          {
            step: 4,
            description:
              'Presione el botón <strong class="text-primary">Redimir.</strong>, Indique el <strong>número de documento </strong> del cliente con el que va a facturar y a continuación presione <strong class="text-primary">Confirmar.</strong>',
            image_path: require('@assets/images/manuals/2_4_redeem.gif'),
            type: 'standard',
          },
        ],
        3: [
          {
            step: 1,
            description:
              'Indique  un rango de tiempo <strong>especificando fecha/hora de inicio y fin</strong> para filtrar bonos redimidos en el tiempo deseado.',
            image_path: require('@assets/images/manuals/3_1_search.gif'),
            type: 'standard',
          },
          {
            step: 2,
            description:
              '<strong>Una vez filtrados los bonos redimidos en el rango de tiempo deseado.</strong>. Presione el botón <i class="fas fa-download border border-primary rounded shadow-sm p-2 text-primary"></i> para generar y <strong>descargar el reporte</strong>.</strong>',
            image_path: require('@assets/images/manuals/3_2_report.gif'),
            type: 'standard',
          },

          {
            step: 3,
            description:
              'Para borrar e iniciar un nuevo reporte presione el botón <strong><i class="fas fa-eraser border border-primary rounded shadow-sm p-2 text-primary"></i></strong>, y <strong>repita los pasos anteriores.</strong>',
            image_path: require('@assets/images/manuals/3_3_clear_filter.gif'),
            type: 'standard',
          },
        ],
        4: [
          {
            step: 1,
            description:
              'Escanee el <strong>código QR y/o código de barras</strong> suministrado por el RT para consultar el detalle de la orden y empezar el proceso de autorización.',
            image_path: require('@assets/images/manuals/payless.gif'),
            type: 'standard',
          },
          {
            step: 2,
            description:
              '<strong>Una vez consultado el detalle de la orden</strong>, si el detalle corresponde a los productos seleccionados por el RT, Presione el botón "autorizar" o la tecla Enter para <strong>Autorizar la orden</strong>.',
            image_path: require('@assets/images/manuals/payless1.gif'),
            type: 'standard',
          },

          {
            step: 3,
            description:
              'En caso de que al escanear el QR o código de barras aparezca el mensaje de la imagen, solicite al RT que le genere un nuevo código y <strong>repita los pasos anteriores.</strong>',
            image_path: require('@assets/images/manuals/payless2.gif'),
            type: 'standard',
          },
        ],
      },
    }
  },
  mounted() {
    let store = JSON.parse(window.localStorage.getItem('store'))
    let cash_register = JSON.parse(window.localStorage.getItem('cash_register'))
    let casher_register = JSON.parse(
      window.localStorage.getItem('casher_register')
    )
    if (store !== null && this.store === null) {
      this.setStore(store)
    }
    if (cash_register !== null && this.cashRegister === {}) {
      console.log('entro to set cash_register')
      this.setCashRegister(cash_register)
    }
    if (casher_register !== null && this.casherRegister === {}) {
      console.log('entro to set casher_register')
      this.setCasherRegister(casher_register)
    }
    this.enabledTabs = Boolean(store && casher_register && casher_register)
  },
  computed: {
    ...mapGetters({
      stores: 'captacionPos/stores',
      store: 'captacionPos/store',
      cashRegister: 'captacionPos/cashRegister',
      casherRegister: 'captacionPos/casherRegister',
    }),
  },

  watch: {
    store(val) {
      this.enabledTabs = Boolean(this.store && this.cashRegister)
    },
    cashRegister(val) {
      this.enabledTabs = Boolean(this.store && this.cashRegister)
    },
    casherRegister(val) {
      this.enabledTabs = Boolean(this.store && this.casherRegister)
    },
  },

  methods: {},
}
</script>

<template>
  <Background>
    <b-card
      no-body
      class="shadow"
      style="height:85vh; max-height:85vh;border-radius:2rem"
    >
      <div class="">
        <b-button
          v-b-modal.modal-scrollable
          class="rounded-circle p-0 help d-flex shadow"
          variant="outline-primary"
        >
          <span class="d-flex mx-auto">?</span>
        </b-button>

        <b-modal
          id="modal-scrollable"
          scrollable
          title="Instructivo"
          size="lg"
          ok-only
          class="shadow"
        >
          <ul class="list-unstyled">
            <b-media
              tag="li"
              v-for="(step, index) in manuals[tabIndex-1]"
              :key="index"
              class="mb-3"
            >
              <template #aside>
                <div
                  class="rounded-circle border border-primary text-center d-flex justify-content-center "
                  :class="
                    step.type === 'standard'
                      ? 'border-primary'
                      : 'border-warning'
                  "
                  style="width: 40px; height: 40px"
                >
                  <h5
                    v-if="step.type === 'standard'"
                    class="align-self-center font-weight-bold text-primary"
                    >{{ step.step }}</h5
                  >
                  <b-icon
                    v-if="step.type === 'info'"
                    class="align-self-center"
                    icon="exclamation-circle-fill"
                    :variant="'warning'"
                    style="width: 30px; height: 30px"
                  />
                </div>
              </template>
              <h5 class="mt-0 mb-1" v-html="step.description"></h5>
              <img
                v-if="step.image_path"
                class="img-fluid rounded shadow"
                :src="step.image_path"
                :alt="`Paso ${step.step}`"
                fluid
              /><img />
            </b-media>
          </ul>
        </b-modal>
      </div>
      <div></div>
      <b-tabs
        pills
        card
        v-model="tabIndex"
        lazy
        content-class="mh-100 overflow-auto bg-light rounded"
        nav-class="p-0 rounded-left bg-white menu"
        active-nav-item-class="bg-yellow rounded border-left border-top p-1 text-primary font-weight-normal "
        vertical
        nav-wrapper-class="col-3"
        class="bg-white shadow"
        style="border-radius: 3rem !important; max-height: 85vh!important;"
      >
        <b-tab title="Tab 1" disabled>
          <template #title>
            <div
              class="p-1 text-center font-weight-normal h5 text-primary nv"
              style="background-color:white"
            >
              <img
                src="../../../public/res/euro.svg"
                alt="login"
                style="max-width: 40%"
                class="my-2"
              />
            </div>
          </template>
        </b-tab>
        <b-tab title="Tab 1" active style="width:100%; height:100%">
          <template #title>
            <div
              :class="{ 'custom-active-nav': tabIndex === 1 }"
              class="p-1 text-center font-weight-normal h5 text-primary nv d-flex align-items-center div-list"
            >
              <i class="fas fa-cash-register h4 "></i>
              <p class="m-1 p-0"> Caja </p>
            </div>
          </template>
          <b-card-text style="width:100%; height:100%">
            <CashRegisterForm> </CashRegisterForm>
          </b-card-text>
        </b-tab>
        <b-tab :disabled="!enabledTabs" style="width:100%; height:100%">
          <template #title>
            <div
              class="p-1 text-center font-weight-normal h5 text-primary nv d-flex align-items-center div-list"
              :class="{
                'custom-active-nav': tabIndex === 2,
                'text-muted': !enabledTabs,
              }"
            >
              <i class="fas fa-user-shield h4"></i>
                <p class="m-1 p-0" style="text-align: initial;">Tratamiento de datos personales</p>
              </div>
            </div>
          </template>
          <div style="width:100%; height:100%">
            <HabeasDataForm></HabeasDataForm>
          </div>
        </b-tab>
        <b-tab :disabled="!enabledTabs">
          <template #title>
            <div
              class="p-1 text-center font-weight-normal h5 text-primary nv d-flex align-items-center div-list"
              :class="{
                'custom-active-nav': tabIndex === 3,
                'text-muted': !enabledTabs,
              }"
            >
              <i class="fas fa-money-bill h4 "></i>
              <p class="m-1 p-0">Bonos</p>
            </div>
          </template>
          <h5>Seleccione</h5>
          <ThirdpartyCardGroup></ThirdpartyCardGroup>
        </b-tab>
        <b-tab :disabled="!enabledTabs">
          <template #title>
            <div
              class="p-1 text-center font-weight-normal h5 text-primary nv d-flex align-items-center div-list"
              :class="{
                'custom-active-nav': tabIndex === 4,
                'text-muted': !enabledTabs,
              }"
            >
              <i class="fas fa-file-download h4 "></i>
              <p class="m-1 p-0">Reportes</p>
            </div>
          </template>
          <b-card-text>
            <RedeemedCouponsTable></RedeemedCouponsTable>
          </b-card-text>
        </b-tab>
        <b-tab :disabled="!enabledTabs">
          <template #title>
            <div
              class="p-1 text-center font-weight-normal h5 text-primary nv d-flex align-items-center div-list"
              :class="{
                'custom-active-nav': tabIndex === 5,
                'text-muted': !enabledTabs,
              }"
            >
              <i class="fas fa-qrcode h4 "></i>
              <p class="m-1 p-0">Payless</p>
            </div>
          </template>
          <b-card-text>
            <PaylessQr></PaylessQr>
          </b-card-text>
        </b-tab>
        <b-tab :disabled="!enabledTabs">
          <template #title>
            <div
              class="p-1 text-center font-weight-normal h5 text-primary nv d-flex align-items-center div-list"
              :class="{
                'custom-active-nav': tabIndex === 4,
                'text-muted': !enabledTabs,
              }"
            >
              <i class="fas fa-file-download h4 "></i>
              <p class="m-1 p-0">Reporte Payless</p>
            </div>
          </template>
          <b-card-text>
            <LogsPaylessTable></LogsPaylessTable>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
  </Background>
</template>
<style lang="scss">
.custom-active-nav {
  border-left: solid 6px #131a79;
}
.nv:hover {
  border-left: solid 6px #ffffff;
  color: #ffffff !important;
}

.nv:hover i::before {
  color: #ffffff !important;
}

.height-footer {
  min-height: 60px;
  max-height: 60px;
}
.nav-link.active.bg-yellow {
  background: rgba(97, 105, 194, 0.233) !important;
}
.nav-link:hover.active.bg-yellow {
  background: #121a79 !important;
  color: #ffffff !important;
}
.nav-item {
  .h4,
  .h5 {
    color: rgba(18, 26, 120, 1) !important;
  }
  .h4:hover,
  .h5:hover {
    color: rgb(255, 255, 255) !important;
  }
  &.disabled .h5,
  &.disabled .h4 {
    color: rgba(18, 26, 120, 0.43) !important;
  }

  &:hover {
    transition: 0.5s;
    border-radius: none;
    background: #121a79 !important;
    color: #fff !important;
    .h4,
    .h5 {
      color: rgb(255, 255, 255) !important;
    }
    .nv {
      border-left: solid 6px rgba(255, 255, 255, 0.5);
    }
  }
}

.help {
  background: rgba(12, 8, 238, 0.144);
  position: absolute;
  z-index: 1;
  right: 30px;
  top: 20px;
  font-size: 35px;
  width: 50px;
  height: 50px;
}
.div-list{
    margin: 4.4px 0!important;
  }
  .menu{
    max-height: 85vh;
    overflow: auto;
    display: grid;
  }
</style>
